module.exports = __webpack_public_path__ + "img/Barlow-SemiBold.6c945de8.svg";